import { useTrackAccount } from "./trackers/useTrackAccount";
import { useTrackCombo } from "./trackers/useTrackCombo";
import { useTrackFeatureFlags } from "./trackers/useTrackFeatureFlags";
import { useTrackIsMarketMaker } from "./trackers/useTrackIsMarketMaker";
import { useTrackMaturityAndPair } from "./trackers/useTrackMaturityAndPair";
import { useTrackOptionInstrument } from "./trackers/useTrackOptionInstrument";
import { useTrackPathName } from "./trackers/useTrackPathName";
import { useTrackTickSize } from "./trackers/useTrackTickSize";

export const useTrackers = () => {
  useTrackAccount();
  useTrackMaturityAndPair();
  useTrackOptionInstrument();
  useTrackPathName();
  useTrackTickSize();
  useTrackCombo();
  useTrackFeatureFlags();
  useTrackIsMarketMaker();
};
